import React, { FC, useContext } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import {
  Context,
  careerSheetPath,
  careerMapPath,
  careerQuestionPath,
} from "../../../store/student";
import { ALERTS } from "../../../constants/career";

import styles from "./MapActionButtons.module.scss";

type Props = {
  createCareerSheets: () => void;
};

const MapActionButtons: FC<Props> = ({ createCareerSheets }) => {
  const { contextState } = useContext(Context);
  const history = useHistory();

  const feedbackQuestions = contextState.career_feedback_questions;
  const latestSheet = contextState.career_latest_sheet;
  const latestFeedbackSheet = contextState.career_latest_feedback_sheet;
  const feedBackSheets = contextState.career_feedback_sheets;

  const isCompletedQuestions = feedbackQuestions.every(
    question => question.realization !== null,
  );

  const isSheetActive =
    !latestSheet ||
    latestSheet.completed_at === null ||
    (feedbackQuestions.length !== 0 && isCompletedQuestions);

  const isMapActive = feedBackSheets.length > 0;

  const unansweredQuestionIndex = feedbackQuestions.findIndex(
    question => question.realization === null,
  );
  const isQuestionActive =
    feedbackQuestions.length !== 0 && !isCompletedQuestions;

  const isGeneratingMap =
    latestSheet !== null &&
    latestSheet.completed_at !== null &&
    latestFeedbackSheet === null;

  const isQuestionsIncomplete = !isCompletedQuestions;

  const hasUnreadGeneratedMap =
    latestFeedbackSheet !== null && latestFeedbackSheet.read_at === null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.block}>
          <label className={styles.label}>今の気持ちや興味を整理しよう。</label>
          <button
            className={clsx(styles.button)}
            disabled={!isSheetActive}
            onClick={() => {
              createCareerSheets();
              history.push(careerSheetPath);
            }}
          >
            <span className={styles.index}>1</span>
            <span className={styles.text}>キャリア開拓シートを記入</span>
            <span className={styles.badge}>8問</span>
          </button>
        </div>
        {isGeneratingMap && (
          <p className={clsx(styles.alert, styles.isActive)}>
            {ALERTS.GENERATING_MAP}
          </p>
        )}
        <div className={styles.block}>
          <label className={styles.label}>
            回答からつくられたあなた専用のキャリアMAPを確認しよう。
          </label>
          <button
            className={clsx(styles.button)}
            disabled={!isMapActive}
            onClick={() => history.push(careerMapPath)}
          >
            <span className={styles.index}>2</span>
            <span className={styles.text}>キャリア開拓MAPを確認</span>
          </button>
        </div>
        {hasUnreadGeneratedMap && (
          <p className={clsx(styles.alert, styles.isActive)}>
            {ALERTS.MAP_COMPLETED}
          </p>
        )}
        <div className={styles.block}>
          <label className={styles.label}>
            “キャリアを広げる問い”に答えて、キャリアを開拓しよう。
          </label>
          <button
            className={clsx(styles.button)}
            disabled={!isQuestionActive}
            onClick={() =>
              history.push(
                `${careerQuestionPath}/${
                  unansweredQuestionIndex === 0 || unansweredQuestionIndex
                    ? unansweredQuestionIndex + 1
                    : 0
                }`,
              )
            }
          >
            <span className={styles.index}>3</span>
            <span className={styles.text}>
              キャリア開拓クエスチョンに答える
            </span>
            <span className={styles.badge}>15問</span>
          </button>
        </div>
        {isQuestionsIncomplete && (
          <p className={clsx(styles.alert, styles.isActive)}>
            {ALERTS.QUESTION_TRY}
          </p>
        )}
      </div>
    </div>
  );
};

export default MapActionButtons;
